/* eslint-disable */
exports.auth_list = [
    {
        "id": 4294968467,
        "parentId": 4294968505,
        "name": "Acc.Management",
        "sort": 2,
        "path": "\/homePage?icon=icon-yonghu",
        "isShow": 1,
        "isCommon": 2,
        "followId": null,
        "packageId": null,
        "privilegeId": null,
        "featureId": 4294968467,
        "createTime": "2021-04-01",
        "auditTemplateId": 10,
        "auditTemplateName": null,
        "openType": 1,
        "isReport": 0,
        "cateType": 1,
        "cityIds": [],
        "children": [
            {
                "id": 4294968468,
                "parentId": 4294968467,
                "name": "Employee List",
                "sort": 2,
                "path": "\/homePage\/memberList?icon=icon-renshu",
                "isShow": 1,
                "isCommon": 2,
                "followId": null,
                "packageId": null,
                "privilegeId": null,
                "featureId": 4294968468,
                "createTime": "2021-04-01",
                "auditTemplateId": 10,
                "auditTemplateName": null,
                "openType": 1,
                "isReport": 0,
                "cateType": 4,
                "cityIds": [],
                "children": null
            }
        ]
    },
    {
        "name": "Dept.Management",
        "sort": 2,
        "path": "\/homePage?icon=icon-department",
        "isShow": 1,
        "isCommon": 2,
        "children": [
            {
                "name": "Department List",
                "sort": 2,
                "path": "\/homePage\/departList?icon=icon-department",
                "isShow": 1,
                "isCommon": 2,
                "children": null
            },
            // {
            //     "name": "Position List",
            //     "sort": 3,
            //     "path": "\/homePage\/positionList?icon=icon-peoples",
            //     "isShow": 1,
            //     "isCommon": 2,
            //     "children": null
            // },
        ]
    }
]